window.addEventListener('DOMContentLoaded', function() {

    // get the intance of the da__modal
    const modals = document.querySelectorAll('.wp-block-lookeen-blocks-modal.da__modal');
    if(!modals) return;

    // loop through the modals
    modals.forEach((modal) => {
        
        console.log(modal);
        // get  attr data-modal-targetfor
        const target = modal.getAttribute('data-modal-targetfor');
        // close button 
        const closeBtn = modal.querySelector('.da__modal-close-btn');
    
        // on element that has class .target
        const targetElement = document.querySelector(`.${target} a`);
        console.log(targetElement);
        
        // click on the target element to open the modal
        targetElement.addEventListener('click', function() {
            console.log(modal);
            modal.classList.add('active');
            // scroll lock the body
            document.body.classList.add('da__modal-open');
        });
    
    
        // click on close button to close the modal
        closeBtn.addEventListener('click', function() {
            modal.classList.remove('active');
            // remove the scroll lock
            document.body.classList.remove('da__modal-open');
        });
    
        // click on the modal to close it
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                modal.classList.remove('active');
            }
        });
    
        
    
    });
    
});